import { forwardRef } from 'react';
import MuiBox from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import {
  splitLegacyBoxProps,
  type LegacyBoxProps,
} from './utils/legacyBoxProps';

/**
 * MUI 5 Box system prop 호환 래퍼 (display·textAlign 등 → sx)
 */
const Box = forwardRef<HTMLDivElement, LegacyBoxProps>((props, ref) => {
  const { forwardedProps, mergedSx } = splitLegacyBoxProps(props);

  return (
    <MuiBox
      ref={ref}
      {...forwardedProps}
      sx={mergedSx as SxProps<Theme>}
    />
  );
});

Box.displayName = 'Box';

export default Box;
export type { LegacyBoxProps } from './utils/legacyBoxProps';
